module.exports = __webpack_public_path__ + "static/img/head.48e0fe3e.png";